import { WbButton, WbEditor } from '@agilelab/plugin-wb-platform';
import { Box, Tooltip, Typography } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import { Skeleton } from '@material-ui/lab';
import { DateTime } from 'luxon';
import { FC, useEffect, useState } from 'react';
import { useEditorPageContext } from '../context/useEditorPageContext';

export const DescriptorCard: FC = () => {
  const {
    descriptorState,
    fetchDescriptor,
    descriptorStateWithComponents,
    fetchDescriptorWithComponents,
    setMonacoEditorRef,
    updatedAt,
  } = useEditorPageContext();

  const [loadingText, setLoadingText] = useState('# Loading components');

  useEffect(() => {
    if (descriptorStateWithComponents.loading) {
      let count = 0;
      const loadingCharacters = ['|', '/', '-', '\\'];
      const interval = setInterval(() => {
        count = (count % loadingCharacters.length) + 1;

        setLoadingText(`# Loading components ${loadingCharacters[count - 1]}`);
      }, 300);

      return () => clearInterval(interval);
    }

    return () => {};
  }, [descriptorStateWithComponents.loading]);

  return (
    <Box height="100%">
      <Box
        style={{
          marginBottom: '16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '30px',
        }}
      >
        <Typography style={{ fontWeight: 500 }}>Descriptor</Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {updatedAt && (
            <Typography
              variant="caption"
              color="textSecondary"
              style={{ fontStyle: 'italic' }}
            >
              {`Updated at: ${DateTime.fromMillis(updatedAt).toFormat(
                'dd/MM/yyyy HH:mm',
              )}`}
            </Typography>
          )}

          <Tooltip title="Refresh the descriptor by reading again all the values from the repositories. After you make a change on the repository files, click this button to reload and see the changes in the descriptor.">
            <WbButton
              variant="outlined"
              onClick={() => {
                fetchDescriptor(true, true);
                fetchDescriptorWithComponents(true, false);
              }}
              label="Refresh"
              icon={<CachedIcon />}
              disabled={descriptorState.loading}
            />
          </Tooltip>
        </div>
      </Box>

      {descriptorState.loading && (
        <Box style={{ width: '100%' }}>
          <Skeleton variant="text" height="3vh" width="15%" />
          <Skeleton variant="text" height="3vh" width="19%" />
          <Skeleton variant="text" height="3vh" width="25%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="37%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="32%" />
          <Skeleton variant="text" height="3vh" width="26%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="32%" />
          <Skeleton variant="text" height="3vh" width="12%" />
          <Skeleton variant="text" height="3vh" width="52%" />
          <Skeleton variant="text" height="3vh" width="37%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="32%" />
          <Skeleton variant="text" height="3vh" width="26%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="37%" />
          <Skeleton variant="text" height="3vh" width="12%" />
          <Skeleton variant="text" height="3vh" width="52%" />
        </Box>
      )}

      {!descriptorState.loading && (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90%',
            overflow: 'hidden',
          }}
        >
          <WbEditor
            theme="white"
            value={
              descriptorStateWithComponents.loading
                ? descriptorState?.value?.replace('components: []', loadingText)
                : descriptorStateWithComponents.value || ''
            }
            options={{ readOnly: true }}
            onMount={setMonacoEditorRef}
          />
        </Box>
      )}
    </Box>
  );
};
